export default __webpack_public_path__ + "file/Fiche-ES-Produit-Puroak-Granulés.asset.fb85e5d5.pdf";